function defaultState() {
  return {
    analysisFilters: {
      actions: [],
      groups: [],
      events: [],
      genders: [],
      ages: [],
      daterange: []
    }
  }
}

const state = defaultState();

const actions = {
  signOutReset({commit}) {
    commit('_reset');
  }
}

const mutations = {
  setAnalysisFilters (state, analysisFilters) {
    state.analysisFilters = analysisFilters;
  },

  resetAnalysisFilters (state) {
    state.analysisFilters = {
      actions: [],
      groups: [],
      events: [],
      genders: [],
      ages: [],
      daterange: []
    };
  },

  _reset(state) {
    const initialState = defaultState();
    for (const key in state) {
      if (state.hasOwnProperty(key)) {
        state[key] = initialState[key];
      }
    }
  }
}

export default {
  state,
  mutations,
  actions
}
